export default __webpack_public_path__ + "static/media/you-can-do-it-1024w.882eb7d5.webp";